import React from "react";
import ProfileHeader from "./ProfileHeader.jsx";
import BasicInformation from "../Dashboard/BasicInformation.jsx";
import Section from "../Dashboard/Sections.jsx";
import Experiance from "../Dashboard/Experiance.jsx";
import Education from "../Dashboard/Education.jsx";
import Projects from "../Dashboard/Projects.jsx";
import Certifications from "../Dashboard/Certifications.jsx";
// import Achivements from "../Dashboard/Achivements.jsx";
import Languages from "../Dashboard/Languages.jsx";

const App = () => {
  return (
    <div className="   overflow-hidden  flex bg-blue-50 min-h-screen p-6">
      <ProfileHeader />
      {/* <BasicInformation /> */}
      <Section gap="gap-6">
        <div>
          <BasicInformation />
        </div>
        <div>
          <Experiance />
        </div>
        <div>
          <Education />
          <Projects />
        </div>
        <div>
          <Certifications />
        </div>
        {/* <div>
          <Achivements />
        </div> */}
        <div>
          <Languages/>
        </div>
      </Section>
    </div>
  );
};

export default App;
